<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <template>
      <v-row class="pa-2" no-gutters>
        <v-col
          class="pa-2 mb-4 sticky-md"
          cols="12"
          md="4"
          style="top: 12px"
        ></v-col>

        <v-col v-show="$vuetify.breakpoint.mdAndUp" cols="8" />

        <v-col
          class="pa-2 sticky-md"
          cols="12"
          md="4"
          style="top: 110px; height: fit-content"
        >
          <v-tabs-items
            v-model="qrShow"
            class="overflow-visible mb-4 mb-md-0"
            touchless
          >
            <v-tab-item>
              <qr-maker
                :image-made="imageMade"
                :loading="loading"
                :svg="svgMade"
              />
              <v-btn class="btn-download" @click="showDialog = true">
                <v-icon>mdi-progress-download</v-icon>
                {{ $t("download_qr") }}              </v-btn>
            </v-tab-item>

            <v-tab-item>
              <component
                :is="theme"
                v-model="cardTexts"
                :components="specialInfo"
              />
            </v-tab-item>
          </v-tabs-items>
        </v-col>

        <v-col class="pa-2 px-0" cols="12" md="8">
          <v-stepper v-model="e6" class="px-0 mx-0 qr-stepper" flat vertical>
            <v-stepper-step :complete="e6 > 1" class="px-0 px-md-4" step="1">
              <div class="row justify-center">
                <div class="col-md-12">
                  <p>وارد کردن اطلاعات محصول</p>
                </div>
                <div class="col-md-6 mt-0 pt-0">
                  <div class="rowinfo">
                    <v-text-field
                      v-model="cardTexts.visitName"
                      :disabled="e6 > 1"
                      append-icon="mdi-pen"
                      class="mt-0 pt-0 contentinfo"
                      clear-icon="mdi-close-circle-outline"
                      clearable
                      dense
                      label="نام محصول شما"
                      outlined
                    />
                    <help-info
                      :element-name="`${serviceName}-${componentName}-visitName-cardTexts`"
                      :service-name="serviceName"
                      :help-data="helpData"
                      class="buttoninfo"
                      label="نام محصول"
                    />
                  </div>
                </div>
              </div>
            </v-stepper-step>
            <v-stepper-content class="pr-1 mx-0 mr-md-7 px-md-4" step="1">
              <div class="rowinfo">
                <v-btn
                  :disabled="e6 > 1"
                  class="mb-4"
                  color="third"
                  outlined
                  @click="clearDefaults"
                >
                  <v-icon class="me-2">mdi-delete</v-icon>
                  حذف اطلاعات پیشفرض
                </v-btn>
                <help-info
                  :element-name="`${serviceName}-${componentName}-clearDefaults-cardTexts`"
                  :service-name="serviceName"
                  :help-data="helpData"
                  class="buttoninfo"
                  label="حذف اطلاعات پیشفرض"
                />
              </div>
              <list-expansion
                flat
                icon="pencil-ruler"
                single
                title="انتخاب طرح قالب"
              >
                <template v-slot:content>
                  <theme-selector2
                    v-model="theme"
                    :components="customTheme"
                    :frames="picFrames"
                  />
                </template>
              </list-expansion>
              <list-expansion
                v-model="cardTexts"
                :components="specialInfo"
                :data="cardTexts"
                flat
              />

              <div class="col-md-12">
                <next-btn
                  :loading="loading"
                  style="background: #1b8d39"
                  @click="markQr(true)"
                />
              </div>
            </v-stepper-content>
          </v-stepper>
        </v-col>

        <custom-popup
          v-model="showDialog"
          :cons="cons"
          hide-confirm
          max-width="900"
          transition="dialog-bottom-transition"
        >
          <template v-slot:helpinfo>
            <help-info
              :element-name="`${serviceName}-${componentName}-download-cardTexts`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              label="دانلود کیوآر"
          /></template>
          <v-card class="px-5">
            <download-file
              v-if="showDialog"
              
              :svg="svgMade ? svgMade : imageMade"
              :visit-name="cardTexts.visitName"
              @close="showDialog = false"
            />
          </v-card>
        </custom-popup>
      </v-row>
    </template>
  </help-info-wrapper>
</template>

<script>
import QrGenerator from "../qrland/components/qrGenerator";
import QrMaker from "../qrland/components/qrMaker";
import { Bus, debounce, RobotAxios } from "@/main";
import QrCustomize from "../qrland/components/qrCustomize.vue";
import DownloadFile from "../qrland/downloadFile";
import QrManagement from "../qrland/components/qrManage/qrManagement";
import ListExpansion from "../../content/fragments/listExpansion";
import NextBtn from "../../content/fragments/nextBtn";
import PrevBtn from "../../content/fragments/prevBtn";
import QrAddressField from "../../content/fragments/qrAddressField";
import NewProCard from "@/view/components/Product/newProCard";
import Features from "@/view/pages/product/features";
import singleProduct from "@/view/components/Product/ProductEditor";
import factoryInfo from "@/view/pages/product/factoryInfo";
import ProductTheme2 from "@/view/pages/product/productTheme2";
import ThemeSelector2 from "@/view/pages/product/themeSelector";
import NewDesign from "@/view/pages/product/newDesign";

const VideoGallerySingle = () =>
  import("@/view/components/Gallery/VideoGallerySingle");

export default {
  name: "productCreateModel",
  components: {
    NewDesign,
    ThemeSelector2,
    ProductTheme2,
    NewProCard,
    QrAddressField,
    PrevBtn,
    NextBtn,
    factoryInfo,
    ListExpansion,
    VideoGallerySingle,
    singleProduct,
    QrManagement,
    DownloadFile,
    QrCustomize,
    QrMaker,
    QrGenerator,
    Features,
  },
  data() {
    return {
      helpData: [],
      serviceName: "Qrland",
      componentName: "productCreateModel",
      theme: "newDesign",
      qrDesign: {},
      cons: { title: "دانلود کیوآر" },
      e6: 1,
      errors: {},
      createdDomain: null,
      createdId: null,
      shortId: null,
      picFrames: [
        { name: "newProCard", src: "/media/frame/themes/2.svg" },
        { name: "productTheme2", src: "/media/frame/themes/t2.webp" },
        { name: "newDesign", src: "/media/bg/product.webp" },
      ],
      customTheme: [
        { name: "newProCard", value: "" },
        { name: "productTheme2", value: "" },
        { name: "newDesign", value: "" },
      ],
      finish: true,
      loading: false,
      showDialog: false,
      specialInfo: [
        {
          name: "factoryInfo",
          value: "",
          title: "اطلاعات مجموعه",
          subtitle: "",
          icon: "account-outline",
          secondName: "اطلاعات مجموعه",
        },
        {
          name: "singleProduct",
          value: "",
          title: "اطلاعات محصول",
          subtitle: "",
          icon: "information-outline",
          model: "singleProduct",
          secondName: "اطلاعات محصول",
        },
        {
          name: "Features",
          value: "",
          title: "افزودن ویژگی محصول",
          subtitle: "",
          icon: "information-outline",
          model: "Features",
          secondName: "ویژگی های محصول",
        },
        {
          name: "imageUploader",
          value: "",
          title: "افزودن تصویر",
          subtitle: "",
          icon: "cloud-upload-outline",
          model: "photo",
          secondName: "گالری عکس",
        },
        {
          name: "VideoGallerySingle",
          value: "",
          title: "گالری ویدئو",
          model: "VideoGallerySingle",
          subtitle: "",
          icon: "video-outline",
          secondName: "گالری ویدئو",
        },
        {
          name: "socialMediaIcons",
          value: "",
          title: "افزودن شبکه های اجتماعی",
          subtitle: "",
          icon: "instagram",
          model: "socialMedia",
          secondName: "شبکه های اجتماعی",
        },
        {
          name: "colorPallete",
          value: "",
          title: "انتخاب رنگ",
          subtitle: "",
          icon: "format-color-fill",
          model: "pallete",
          secondName: "",
        },
      ],
      headColor: "linear-gradient(to right , #D81A1AFF, #2115A7FF)",
      bodyColors: "",
      eyeStyle: "",
      qrStyle: "",
      qrSize: "",
      dtUrl: null,
      domainId: null,
     cardTexts: {
        audiosGallery: {
          audios: [],
          audioType: "newPlayer",
        },
        advanceSettings: {
          viewConfigs: {
            autoCsvDownload: false,
            showCClubOnload: false,
            forcedSubmission: "optional",
          },
        },
        customerClub: {
          configs: {
            isActive: true,
            smsType: "pattern",
            patternId: 487,
          },
        },
        pallete: {
          headColor: "linear-gradient(to top left , #00BCD4FF, #2F0743FF)",
          bodyColor: "linear-gradient(to top left , #006064FF, #03A9F4FF)",
          textColor: "#ffffff",
          borderColor: "#393939",
        },
        Features: {
          show: "accordion",
          details: [
            {
              name: "ویژگی های محصول",
              showIt: false,
              value: [
                {
                  label: "",
                  value: "•سیستم میکروپروسسوری با دقت بالا (۰.۱ ثانیه)",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value:
                    "•دارای نمایشگر •Time Value: زمان •Mode: حالت کاری •Rel: وصل رله",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value:
                    "•دارای ۸ حالت مختلف کاری: تایمر: ۱. دهم ثانیه ۲. ثانیه ۳. دقیقه ۴. ساعت فلاشر: ۵. دهم ثانیه ۶ .ثانیه ۷. دقیقه ۸. ساعت",
                  icon: "",
                  name: "",
                  link: "",
                },
                {
                  label: "",
                  value: "•تعیین وضعیت رله (وصل یا قطع) در شروع زمان گیری",
                  icon: "",
                  name: "",
                  link: "",
                },
              ],
            },
          ],
        },
        singleProduct: {
          name: "سوپر تایمر دیجیتال",
          description:
            "سوپر تایمر دیجیتال شیوا امواج تایمری با دقت و کارآیی بسیار بالا و قابل استفاده در رنج وسیعی از محدوده زمانی (از ۰.۱ ثانیه تا ۹۹۹ ساعت) می باشد . همچنین این تایمر می تواند در ۴حالت دهم ثانیه ، ثانیه ، دقیقه و ساعت به صورت فلاشر کار کند . سوپر تایمر شیوا امواج را می توانید در ۲حالت تایمر تأخیر در قطع و تایمر تأخیر در وصل مورد استفاده قرار دهید . تغذیه این تایمر از ترمینال های START مجزا است و در ۲ مدل با تغذیهACو DC عرضه می شود .",
          price: 6915000,
          discount: "3",
          payLink: "",
          btnSetting: {
            title: "خرید",
            icon: undefined,
            background: "linear-gradient(to top left , #D81A1AFF, #2115A7FF)",
            color: "white",
          },
          extra: [
            {
              label: "",
              value: "",
              icon: "",
              name: "",
              link: "",
            },
          ],
          image: "",
          color: undefined,
          arm: [],
        },
        visitName: this.$t("product_introduction"),
        isGradient: false,
        organizationName: this.$t("shiva_waves"),
        subOrgan: this.$t("think_best"),
        userName: "",
        workField: "1373",
        phoneNumber: [
          { number: "09134034351", text: "" },
          { number: "09130363030", text: "" },
        ],
        extraFields: [{ icon: "", name: "", value: "" }],
        companyNumber: "03135723690",
        companyNumberName: "",
        email: "info@shivaamvaj.com",
        fax: "03135723400",
        location: "ایران ،زنجان،ابهر،شهرک صنعتی شریف ، جنب پست برق 63/20",
        city: "",
        photo: {
          gallery: [
            {
              name: "",
              images: [],
            },
          ],
          background: "",
          headBackground: "",
          profile: "",
          transition: "scale",
          hasWelcome: false,
          hasGif: false,
          hasGame: false,

          previewerQr: {
            previewer: {
              gif: "",
              game: {},
              transition: "scale",
            },
          },
        },
        codePostal: "1541946815",
        province: "",
        country: "",
        website: "www.shivaamvaj.com",
        socialMedia: {},
        aboutUs: "",
        // VideoGallerySingle: {
        //   "name": "",
        //   "videos": []
        // },
        VideoGallery: {
          title: "گالری ویدئو",
          description: "از ویدئوهای مجموع ما دیدن فرمایید.",
          sectionColor: {
            backGround: "",
            text: "",
          },
        },
        video_gallery: [
          {
            name: "گالری",
            images: [
              {
                name: "خوش آمدگویی",
                title: "",
                file_link:
                  "https://persian7.asset.aparat.com/aparat-video/1d2d2d8b5fea10b3cbda4fb6e2c45c7653042587-1080p.apt?wmsAuthSign=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6IjFmMmE5MjgyOWMyZjEzOGNkZmRlMWFlOGU2MzJmNGQxIiwiZXhwIjoxNzE4NDMzMjQ1LCJpc3MiOiJTYWJhIElkZWEgR1NJRyJ9.su36sCl2UH54sLhnn78_dHggUySs2d0CKGs3vW5UTH8",
                description: "",
                link: "",
                id: 15,
              },
            ],
          },
        ],
        center: [51.420296, 35.732379],
        coordinates: [51.420296, 35.732379],
        address: "",
        apiKey:
          "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg",
      },
      qrShow: 1,
      svgMade: "",
      imageMade: "",
      destinationUrl: "",
    };
  },
  watch: {
    "cardTexts.photo.gallery": {
      deep: true,

      handler(val) {
        this.$root.$emit("rerenderSwiper");
      },
    },
    qrDesign: {
      handler() {
        if (this.destinationUrl) {
          this.loading = true;
          try {
            debounce(() => {
              this.preview(this.destinationUrl);
            }, 3000);
          } catch (e) {
            this.loading = false;
          }
        }
      },
      deep: true,
    },
    eyeStyle() {
      this.markQr(false);
    },
    qrStyle() {
      this.markQr(false);
    },
    qrSize() {
      this.markQr(false);
    },
  },
  computed: {
    backgroundUrl() {
      return this.$cdnUrl + "/upload/64b2bb1c4ad38.webp";
    },
    headBackground() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },
    profileUrl() {
      return this.$cdnUrl + "/upload/64b2abe4bab25.webp";
    },

  },
  mounted() {
    this.cardTexts.photo.background = this.backgroundUrl;
    this.cardTexts.photo.headBackground = this.headBackgroundUrl;
    this.cardTexts.photo.profile = this.profileUrl;
    this.cardTexts.socialMedia = {
      address: [
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qrland.ir",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
        {
          label: "آدرس",
          text: "لینک سایت مورد نظر را وارد نمایید",
          pattern: "",
          prefix: "URL",
          url: "qr.terminalads.com",
          img: "/media/socialIcon/40icon/location.svg",
          svg: "svgLocation",
        },
      ],
      instagram: [
        {
          label: "اینستاگرام",
          text: "نام کاربری خود را وارد نمایید",
          pattern: "https://instagram.com/",
          prefix: "@",
          url: "terminalads",
          img: "/media/socialIcon/40icon/instagram.svg",
          svg: "svgInstagram",
        },
      ],
      whatsapp: [
        {
          label: "واتساپ",
          text: "+989123456789",
          pattern: "wa.me/",
          prefix: "mdi-phone",
          url: "+982191017077",
          img: "/media/socialIcon/40icon/whatsapp.svg",
          svg: "svgWhatsapp",
        },
      ],
    };

    this.qrDesign = {
      qrStyleColors: {
        backcolor: "",
        frontColor: "",
        gradient_color: "",
        gradient: false,
        pattern: "default",
      },
      MarkerCenter: {
        topRight: "",
        bottomLeft: "",
        main: "",
        different_markers_color: false,
        eyePattern: "default",
      },
      QrMarkOut: {
        topRight: "",
        bottomLeft: "",
        markOutPattern: "default",
        main: "",
        different_markers_color: false,
      },
      QrFrame: {
        main: "",
        text: "SCAN ME",
        framePattern: "none",
        different_markers_color: false,
      },
      LogoImg: { noBg: false, logoSize: 100, logoImg: "none" },
    };

    Bus.$on("colorPalette", (value) => {
      this.cardTexts.pallete = value;
    });

    Bus.$on("socialMedias", (value) => {
      this.cardTexts.socialMedia = value;
    });

    Bus.$on("uploader", (value) => {
      this.cardTexts.photo = value;
    });

    Bus.$on("gradientType", (value) => {
      this.cardTexts.isGradient = value;
    });

    Bus.$on("eyeStyle", (value) => {
      this.eyeStyle = value;
    });

    Bus.$on("qrStyle", (value) => {
      this.qrStyle = value;
    });
  },
  methods: {
    markQr(final = false) {
      this.loading = true;
      let obj = {
        type: "productModel",
        qrType: "dynamic",
        title: this.cardTexts.visitName,
        domain_id: this.domainId,
        data: JSON.stringify({
          theme: this.theme,
          data: this.cardTexts,
        }),
        qr: {
          section: "#link",
          link: "https://qr2.in/",
          backcolor: "#ffffff",
          frontcolor: "#000000",
          gradient_color: "#000000",
          marker_out_color: "#000000",
          marker_in_color: "#000000",
          marker_top_right_outline: "#000000",
          marker_top_right_center: "#000000",
          marker_bottom_left_outline: "#000000",
          marker_bottom_left_center: "#000000",
          framecolor: "#000000",
          optionlogo: "none",
          "logo-size": 100,
          marker: "default",
          marker_in: "default",
          outer_frame: "none",
          framelabel: "SCAN ME",
          label_font: "AbrilFatface.svg",
          "label-text-size": 100,
          size: "248",
          level: "M",
        },
      };

      if (this.dtUrl && this.dtUrl.length > 0) {
        obj.identifier = this.dtUrl;
      }

      this.$api
        .post("qr/template", {
        qr: obj,
        type: "productModel",
        title: this.cardTexts.visitName,
      })
        .then(({ data }) => {
          this.finish = final;
          this.loading = false;
          this.$toast.success("کارت محصول شما با موفقیت ساخته شد.");
          if(!!this.finish)
          this.$router.replace({ name: "modelsList" });
        })
        .catch(({ response }) => {
          this.errors = response.data.errors;
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    preview(link) {
      this.loading = true;
      this.$api
        .post("/v1/Qr/preview", {
          section: "#link",
          link: link,
          backcolor: !this.qrDesign.qrStyleColors?.backcolor
            ? "#ffffff"
            : this.qrDesign.qrStyleColors?.backcolor,
          gradient_color: !this.qrDesign.qrStyleColors?.gradient_color
            ? "#8900d5"
            : this.qrDesign.qrStyleColors?.gradient_color,
          frontcolor: !this.qrDesign.qrStyleColors?.frontColor
            ? "#000000"
            : this.qrDesign.qrStyleColors?.frontColor,
          gradient: this.qrDesign.qrStyleColors?.gradient ? "on" : "",
          pattern: this.qrDesign.qrStyleColors.pattern,
          marker_in: this.qrDesign.MarkerCenter.eyePattern,
          marker_in_color: this.qrDesign.MarkerCenter.main,
          markers_color: this.qrDesign.MarkerCenter.different_markers_color
            ? "on"
            : "",
          marker: this.qrDesign.QrMarkOut.markOutPattern,
          different_markers_color:
            this.qrDesign.QrMarkOut.different_markers_color ||
            this.qrDesign.MarkerCenter.different_markers_color
              ? "on"
              : "",
          marker_out_color: this.qrDesign.QrMarkOut.main,
          marker_top_right_outline: this.qrDesign.QrMarkOut.topRight,
          marker_top_right_center: this.qrDesign.MarkerCenter.topRight,
          marker_bottom_left_outline: this.qrDesign.QrMarkOut.bottomLeft,
          marker_bottom_left_center: this.qrDesign.MarkerCenter.bottomLeft,
          custom_frame_color: this.qrDesign.QrFrame?.different_markers_color
            ? "on"
            : "",
          outer_frame: this.qrDesign.QrFrame.framePattern,
          framecolor: this.qrDesign.QrFrame.main,
          framelabel: this.qrDesign.QrFrame.text,
          optionlogo: this.qrDesign.LogoImg.logoImg,
          no_logo_bg: this.qrDesign.LogoImg.noBg ? "on" : "",
          "logo-size": this.qrDesign.LogoImg.logoSize,
          label_font: "AbrilFatface.svg",
          "label-text-size": "100",
          size: "248",
          level: "H",
        })
        .then((res) => {
          this.loading = false;
          this.imageMade = null;
          this.svgMade = res.data.data;
        })
        .catch((err) => {
          this.loading = false;
          // this.$toast.error('خطای سرور!')
        })
        .finally(() => {
          this.loading = false;
        });
    },
    async setSettings() {
      this.loading = true;
      const res = await this.$refs.qrManage.update();
      this.loading = false;
      this.e6 = 3;
    },
    qrUpdate(final = false) {
      this.loading = true;

      const data = new URLSearchParams();
      data.append("type", "singleProduct");
      data.append("qrType", "dynamic");
      data.append("domain", this.createdDomain);
      data.append("identifier", this.createdId || "");

      data.append("qr[section]", "#link");
      data.append(
        "qr[backcolor]",
        !this.qrDesign.qrStyleColors?.backcolor
          ? "#ffffff"
          : this.qrDesign.qrStyleColors?.backcolor,
      );
      data.append(
        "qr[gradient_color]",
        !this.qrDesign.qrStyleColors?.gradient_color
          ? "#000000"
          : this.qrDesign.qrStyleColors?.gradient_color,
      );
      data.append(
        "qr[frontcolor]",
        !this.qrDesign.qrStyleColors?.frontColor
          ? "#000000"
          : this.qrDesign.qrStyleColors?.frontColor,
      );
      data.append(
        "qr[gradient]",
        this.qrDesign.qrStyleColors?.gradient ? "on" : "",
      );
      data.append("qr[pattern]", this.qrDesign.qrStyleColors.pattern);
      data.append("qr[marker_in]", this.qrDesign.MarkerCenter.eyePattern);
      data.append("qr[marker_in_color]", this.qrDesign.MarkerCenter.main);
      data.append(
        "qr[markers_color]",
        this.qrDesign.MarkerCenter.different_markers_color ? "on" : "",
      );
      data.append("qr[marker]", this.qrDesign.QrMarkOut.markOutPattern);
      data.append(
        "qr[different_markers_color]",
        this.qrDesign.QrMarkOut.different_markers_color ||
          this.qrDesign.MarkerCenter.different_markers_color
          ? "on"
          : "",
      );
      data.append("qr[marker_out_color]", this.qrDesign.QrMarkOut.main);
      data.append(
        "qr[marker_top_right_outline]",
        this.qrDesign.QrMarkOut.topRight,
      );
      data.append(
        "qr[marker_top_right_center]",
        this.qrDesign.MarkerCenter.topRight,
      );
      data.append(
        "qr[marker_bottom_left_outline]",
        this.qrDesign.QrMarkOut.bottomLeft,
      );
      data.append(
        "qr[marker_bottom_left_center]",
        this.qrDesign.MarkerCenter.bottomLeft,
      );
      data.append(
        "qr[custom_frame_color]",
        this.qrDesign.QrFrame?.different_markers_color ? "on" : "",
      );
      data.append("qr[outer_frame]", this.qrDesign.QrFrame.framePattern);
      data.append("qr[framecolor]", this.qrDesign.QrFrame.main);
      data.append("qr[framelabel]", this.qrDesign.QrFrame.text);
      data.append("qr[optionlogo]", this.qrDesign.LogoImg.logoImg);
      data.append("qr[no_logo_bg]", this.qrDesign.LogoImg.noBg ? "on" : "");
      data.append("qr[label_font]", "AbrilFatface.svg");
      data.append("qr[size]", "248");
      data.append("qr[level]", "H");
      data.append('qr["logo-size"]', this.qrDesign.LogoImg.logoSize);
      data.append('qr["label-text-size"]', "100");

      this.$api
        .put("/v1/testQr/update", data, {
          headers: {
            "Content-Type": "application/x-www-form-urlencoded",
          },
        })
        .then((res) => {
          this.finish = final;
          this.$toast.success("کیوآر محصول شما باموفقیت ویرایش شد.");
        })
        .catch((err) => {
          this.loading = false;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    clearDefaults() {
      this.$root.$emit("clearDefaultData");
      this.cardTexts.visitName = "";
      this.cardTexts.isGradient = false;
      this.cardTexts.organizationName = "";
      this.cardTexts.subOrgan = "";
      this.cardTexts.userName = "";
      this.cardTexts.workField = "";
      this.cardTexts.phoneNumber = [{ number: "" }];
      this.cardTexts.extraFields = [
        {
          icon: "",
          name: "",
          value: "",
        },
      ];
      this.cardTexts.Features = {
        show: "accordion",
        details: [
          {
            name: "",
            showIt: false,
            value: [],
          },
        ],
      };
      this.cardTexts.companyNumber = "";
      this.cardTexts.email = "";
      this.cardTexts.fax = "";
      this.cardTexts.location = "";
      this.cardTexts.city = "";
      this.cardTexts.singleProduct = {
        title: "",
        content: "",
        price: null,
        discount: "",
        payLink: "",
        details: [
          {
            label: "",
            value: "",
            icon: "",
            name: "",
            link: "",
          },
        ],
        image: undefined,
        color: undefined,
        icon: undefined,
        arm: [],
      };
      this.cardTexts.photo = {
        gallery: null,
        headBackground: "",
        profile: "",
        transition: "scale",
        hasWelcome: false,
        hasGif: false,
        hasGame: false,

        previewerQr: {
          previewer: {
            gif: "",
            game: {},
            transition: "scale",
          },
        },
      };
      this.cardTexts.codePostal = "";
      this.cardTexts.province = "";
      this.cardTexts.country = "";
      this.cardTexts.website = "";
      this.cardTexts.socialMedia = {};
      this.cardTexts.aboutUs = "";
      this.cardTexts.video_single = {
        name: "",
        videos: [],
      };
      this.cardTexts.center = [51.420296, 35.732379];
      this.cardTexts.coordinates = null;
      this.cardTexts.address = "";
      this.cardTexts.apiKey =
        "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIn0.eyJhdWQiOiIyMDI5NSIsImp0aSI6ImZhZjI0ZjA0Y2U2NTQ2ZDAyYzMwNjBmMzAxYWY0NTMxYjhkOTEwODVhMDQ3MGY1ZDc3YjYwY2M4OGRiNjVkZjZkMjIyZWNkZjNmMTJkYmExIiwiaWF0IjoxNjcwNjg5MDc4LCJuYmYiOjE2NzA2ODkwNzgsImV4cCI6MTY3MzE5NDY3OCwic3ViIjoiIiwic2NvcGVzIjpbImJhc2ljIl19.h-KYgigwSQbp9KYjIjWgBLQRpMy6ABa40dyF4pF99UmndnhDNs-fckFePIdRPkm7GlggWm9yKphj_TJ5b9TyA8m1_gNarjRiPzhAS5ZNGNUaSfnGHA1cUbc71DuUKgohAe2sOmXUkKin0q-ErzDdCczJjLVc218dRkCxLuJIrAY5yZ5yVgK79-Q6misDYP3yLpWaV5uDA3a1VzXppq4G9hm0GCGmsef_WryEx9z1fFuOzoVbuNj2yEKn3mBi2vAyKvV1HRMKMoXy_KLTk8xy-GsSQArOxKvw4Nk8Nvuks0WzSlLygNncQozltpm5Z4kueep-0TrI4xzx6uSjuk20vg";
    },
  },
};
</script>

<style scoped>
.v-tab--active {
  background-color: var(--v-primary-base) !important;
  border-radius: 50px;
  color: white;
}
</style>
